import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {takeUntil} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {ThresholdDictionary} from '../../../../shared/interface/threshold-dictionary';
import {ThresholdService} from '../../../../shared/services/threshold.service';
import {ThresholdDictionaryGroup} from '../../../../shared/interface/threshold-dictionary-group';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-threshold-group-form',
  templateUrl: './threshold-group-form.component.html',
  styleUrls: ['./threshold-group-form.component.scss']
})
export class ThresholdGroupFormComponent implements OnInit, OnDestroy {
  @Input() thresholdDictionary: ThresholdDictionary;
  @Output() closeModification: EventEmitter<boolean> = new EventEmitter<boolean>();

  formGroupsValid = false;
  formGroups: FormArray;
  processingRequest = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private thresholdService: ThresholdService,
    private snack: MatSnackBar,
  ) {
    this.formGroups = fb.array([]);
  }

  ngOnInit(): void {
    this.formGroups.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => this.formGroupsValid = this.formGroups.valid);

    this.thresholdDictionary.groups.forEach((group: ThresholdDictionaryGroup) => {
      this.addGroup(group);
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  cancel(): void {
    this.closeModification.emit(false);
  }

  addGroup(initialValue?: ThresholdDictionaryGroup): void {
    const formGroup = this.fb.group({
      uuid: this.fb.control(initialValue ? initialValue.uuid : uuidv4()),
      groupName: this.fb.control(initialValue ? initialValue.groupName : ''),
      riskCodes: this.fb.control(initialValue ? initialValue.riskCodes : [], []),
      internalRisk: this.fb.control(initialValue ? initialValue.internalRisk?.id : ''),
    });

    this.formGroups.push(formGroup);
  }

  removeGroup(i: number): void {
    this.formGroups.removeAt(i);
  }

  save(): void {
    this.processingRequest = true;

    this.thresholdService.configure(this.thresholdDictionary.uuid, {groups: this.formGroups.value})
      .subscribe({
        next: () => {
          this.processingRequest = false;
          this.snack.open('Konfiguracja została pomyślnie zapisana', '', {duration: 2000});
          this.closeModification.emit(true);
        },
        error: (error: HttpErrorResponse) => {
          this.processingRequest = false;
          this.snack.open('Przy zapisywaniu konfiguracji wystąpił błąd', error.status.toString(), {duration: 2000});
        }
      });
  }

  getRiskRatesForms(riskFormGroup: FormGroup, type: string): FormGroup[] {
    const result: FormGroup[] = [];

    (riskFormGroup.get('customRates') as FormArray).controls.forEach((formGroup: FormGroup) => {
      if (formGroup.get('type').value === type) {
        result.push(formGroup);
      }
    });

    return result;
  }
}
